// Paramètres de campagne (UTM + click IDs) : cookie first-party 30 jours, dernier clic gagnant.
const COOKIE = "lapaire_utm";
const KEYS = ["utm_source", "utm_medium", "utm_campaign", "utm_content", "gclid", "fbclid", "ttclid"] as const;

export function captureUtmRef(): void {
  if (typeof window === "undefined") return;
  const params = new URLSearchParams(window.location.search);
  const data: Record<string, string> = {};
  for (const k of KEYS) {
    const v = params.get(k)?.trim();
    if (v) data[k] = v.slice(0, 200);
  }
  if (Object.keys(data).length === 0) return;
  document.cookie = `${COOKIE}=${encodeURIComponent(JSON.stringify(data))}; max-age=${30 * 86400}; path=/; SameSite=Lax`;
}

export function getUtmRef(): Record<string, string> | null {
  if (typeof document === "undefined") return null;
  const m = document.cookie.match(new RegExp(`(?:^|; )${COOKIE}=([^;]*)`));
  if (!m?.[1]) return null;
  try {
    return JSON.parse(decodeURIComponent(m[1]));
  } catch {
    return null;
  }
}

/** Chaîne de requête courante ("?a=1" ou ""), à reporter sur les transitions de pays. */
export function currentSearch(): string {
  return typeof window === "undefined" ? "" : window.location.search;
}

/** Normalise une chaîne de requête en "?a=1" (ou "") quel que soit le nombre de "?" en tête. */
export function normalizeSearch(s: string | null | undefined): string {
  const q = String(s ?? "").replace(/^\?+/, "");
  return q ? `?${q}` : "";
}
